// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const StripeIntegration = {
    GetPayoutDescriptor(fn, req) {
        return fn(`/payments-platform/stripe-integration/payout-descriptors`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
